<div class="header">
    <h3 mat-dialog-title>
        <fa-icon icon="stopwatch" style="margin-right: 5px"></fa-icon>
        Zeitenliste
    </h3>
    <span class="spacer"></span>
    <button 
        app-round-button 
        matTooltip="Filter" 
        aria-label="Filter"  
        (click)="$event.stopPropagation(); 
        filter.Open()" [matBadge]="FilterAmount$ | async" 
        [matBadgeHidden]="!(FilterAmount$ | async)"
        >
        <fa-icon icon="filter"></fa-icon>
    </button>
    <app-filter-card 
        #filter 
        UnlimitedHeight 
        [Settings]="FilterSettings$ | async" 
        [Values]="FilterValues$ | async" 
        (ValuesChange)="FilterValues$.next($event)" 
        (click)="$event.stopPropagation()"></app-filter-card
    >
    <button 
        mat-icon-button 
        matDialogClose 
        matTooltip="Schließen"
    >
        <fa-icon icon="times" size="2x"></fa-icon>
    </button>
</div>
<mat-dialog-content *ngIf="DataSource$ | async as data" style="height: 100vh;">
    <table mat-table [dataSource]="data" class="main-table">
        <!-- Table Columns -->
        <ng-container *ngFor="let column of TableColumns" [matColumnDef]="column.name">
            <th mat-header-cell *matHeaderCellDef>{{ column.header }}</th>
            <td mat-cell *matCellDef="let rowData">{{ rowData[column.name] }}</td>
            <td mat-footer-cell *matFooterCellDef>{{ getTotal(column, data) }}</td>
        </ng-container>
        <ng-container *ngFor="let column of clockInTypeColumns$ | async" [matColumnDef]="column.columnName">
            <th mat-header-cell *matHeaderCellDef>{{ column.header }}</th>
            <td mat-cell *matCellDef="let rowData">{{ rowData.cTypes$.get(column.columnName) }}</td>
            <td mat-footer-cell *matFooterCellDef>{{ getTotalCType(column.columnName, data) }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns$ | async"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns$ | async"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns$ | async"></tr>
    </table>
</mat-dialog-content>
